<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="users"
      :options.sync="options"
      :server-items-length="totalRoles"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [-1],
        // showFirstLastPage: true,
      }"
      sort-by="role"
      :style="{ padding: '10px', height: '70vh' }"
      fixed-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <v-dialog v-model="dialog" max-width="300px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                :style="{ 'margin-right': '10px' }"
                v-on="on"
              >
                New Role
              </v-btn>
            </template>

            <v-card>
              <v-form>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.role"
                          label="Role Name"
                          :error-messages="roleErrors"
                          @change="$v.editedItem.role.$touch()"
                          @blur="$v.editedItem.role.$touch()"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col v-if="editedIndex == -1" cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.description"
                          label="Description"
                          :error-messages="descriptionErrors"
                          @change="$v.editedItem.description.$touch()"
                          @blur="$v.editedItem.description.$touch()"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn
                    v-if="!view"
                    color="blue darken-1"
                    text
                    :loading="loading"
                    :disabled="loading"
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <template>
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              ><v-icon>mdi-restart</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </template>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.role }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="viewItem(item)">
              mdi-eye
            </v-icon>

            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getData"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { date } from '../../lib/helpers';

export default {
  mixins: [validationMixin],
  validations: {
    editedItem: {
      role: {
        required,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.role == null ||
              this.errorValidation.role.length < 1)
          );
        },
      },
      description: {},
    },
  },
  data: () => ({
    search: {
      role: '',
      description: '',
    },
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        sortable: false,
        width: '10',
      },
      {
        text: 'Role',
        value: 'role',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Actions',
        width: '150',
        value: 'actions',
        sortable: false,
      },
    ],
    editedIndex: -1,
    editedItem: {
      role: '',
      description: '',
    },
    defaultItem: {
      role: '',
      description: '',
    },
    selectedRow: '',
    // errorValidation: {
    //     role: [],
    //     description: [],
    // },
  }),

  computed: {
    formTitle() {
      let role = '';
      if (this.editedIndex != -1) {
        if (this.editedIndex == -2) {
          role = 'View Role ID';
        } else role = 'Edit Role ID';
      } else role = 'New Role ID';
      return role;
    },
    flashErrorMessage() {
      return this.$store.state.rbac.role.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.rbac.role.flashError;
      },
      set() {
        this.$store.commit('rbac/role/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.rbac.role.errors;
    },
    loading() {
      return this.$store.state.rbac.role.loading;
    },
    users() {
      return this.$store.state.rbac.role.allRoles;
    },
    totalRoles() {
      return this.$store.state.rbac.role.totalRoles;
    },
    totalPage() {
      return this.$store.state.rbac.role.totalPage;
    },
    itemsRole() {
      return this.$store.state.rbac.allRole;
    },
    roleErrors() {
      const errors = [];
      if (!this.$v.editedItem.role.$dirty) {
        return errors;
      }
      if (!this.$v.editedItem.role.required)
        errors.push('Rolename is required.');
      if (!this.$v.editedItem.role.isUnique) {
        if (this.errorValidation != null && this.errorValidation.role != null) {
          this.errorValidation.role.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      return errors;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    dialogDelete(val) {
      if (!val) this.closeDelete();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'editedItem.role': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.role != null &&
            val != this.errorValidation.role
          ) {
            this.$store.commit('rbac/role/clearErrorVariable', 'role');
          }
        }
      },
    },

    show() {
      if (!this.show) {
        this.search.role = '';
        this.search.description = '';
        this.$nextTick(() => {
          this.getData();
        });
      }
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.role = '';
      this.search.description = '';
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    getData() {
      this.$store.commit('rbac/role/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('rbac/role/fetchRoles', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
      });
    },

    viewItem(item) {
      this.editedIndex = this.$store.state.rbac.role.allRoles.indexOf(item);
      this.editedItem = { ...item };
      this.view = true;
      this.editedIndex = -2;
      this.dialog = true;
    },

    editItem(item) {
      this.view = false;
      this.editedIndex = this.$store.state.rbac.role.allRoles.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.$store.state.rbac.role.allRoles.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await this.$store
        .dispatch('rbac/role/deleteRole', {
          date,
          role: this.editedItem.role,
        })
        .then(() => {
          this.closeDelete();
        });
    },

    close() {
      this.resetUniqueValidation();
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('rbac/role/setFlashErrorMessage', '');
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    checkRole(item) {
      return item.id == this.editedItem.role.id;
    },

    resetUniqueValidation() {
      this.$store.commit('rbac/role/clearErrors');
    },

    async save() {
      this.$store.commit('rbac/role/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.editedIndex > -1) {
          await this.$store
            .dispatch('rbac/role/updateRole', {
              date,
              role: this.editedItem.role,
              description: this.editedItem.description,
              index: this.editedIndex,
            })
            .then((status) => {
              if (status) {
                this.close();
              }
            });
        } else {
          await this.$store
            .dispatch('rbac/role/createRole', {
              date,
              role: this.editedItem.role,
              description: this.editedItem.description,
            })
            .then((status) => {
              if (status) {
                this.close();
              }
            });
        }
      }
    },

    exportItem() {},
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
